import { createReducer, on } from '@ngrx/store'
import * as AuthActions from './authentication.actions';

export interface AuthState {
  user: any;
  token: string;
  permissions: string[];
  // True once the /me permissions call has resolved (success OR failure) — lets the permission guard WAIT for
  // real data instead of reading the initial empty array and wrongly redirecting to 403.
  permissionsLoaded: boolean;
  error: any;
  isAuthenticated: boolean;
}

export const initialState: AuthState = {
  user: null,
  token: '',
  permissions: [],
  permissionsLoaded: false,
  error: null,
  isAuthenticated: false,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.loginSuccess, (state, { user, token }) => ({
    ...state,
    user,
    token,
    isAuthenticated: true,
    error: null,
  })),
  on(AuthActions.setUser, (state, { user }) => ({
    ...state,
    user,
  })),
  on(AuthActions.setPermissions, (state, { permissions }) => ({
    ...state,
    permissions,
    permissionsLoaded: true,
  })),
  on(AuthActions.loginFailure, (state, { error }) => ({
    ...state,
    error,
    isAuthenticated: false,
  })),
  on(AuthActions.logout, (state) => ({
    ...state,
    user: null,
    token: '',
    permissions: [],
    permissionsLoaded: false,
    isAuthenticated: false,
    error: null,
  }))
);
